import React from "react";
import { withRouter } from "react-router-dom";

import { getQueryParams } from "@/utils/filters";
import { HIPAA } from "@/core/constants";
import { Policy } from "@/components/Policy/Policy";

const HipaaPolicyPage = (props) => {
  const version = getQueryParams("version", props.location.search);

  return <Policy policyType={HIPAA} version={version} />;
};

export default withRouter(HipaaPolicyPage);
